<style lang="scss">
.tablelist-tabs {
	border-bottom: 1px solid #2d8cf0;
	margin-bottom: 10px;
	.vview-button {
		min-width: 100px;
		height: 36px;
		border-radius: 0 !important;
	}
}
.adaptive-tabs {
	border-bottom: 1px solid #2d8cf0;
	margin-bottom: 10px;
	.vview-button {
		min-width: auto;
		height: 36px;
		border-radius: 0 !important;
	}
}
</style>
<template>
	<vButtonGroup class="clearfix" :class="Adaptive.show ? 'adaptive-tabs': 'tablelist-tabs'" compact>
        <div style="display: inline-block;" v-for="(item,index) in data"
			:key="index"
        >
            <compRender v-if="item.render" v-bind="getRenderProps(item)" @on-search="handleSearch" />
            <vButton
                v-else
                :theme="handleActive(item)"
                @click.native="handleSearch(item)"
            >{{handleCompatibleLabel(item)}}
            <span
                v-if="showSpan && item.spanKey && spanNumData[item.spanKey]!==0"
                class="number"
            >{{spanNumData[item.spanKey]}}</span>
            </vButton>
        </div>
	</vButtonGroup>
</template>

<script>
import compRender from "./renderfn";
export default {
	props: ['data', 'defaultKey', 'formData','Adaptive','showSpan','spanNumData'],
    components: {
        compRender
    },
	data() {
		return {

		}
	},
    created () {
        console.log("tabs", this.data);
    },
	methods: {
		//兼容老代码name属性
		handleCompatibleLabel(data) {
			return data.langKey ? $t(data.langKey, { defaultValue: data.name || data.label }) : (data.name || data.label)
		},
		// 兼容老代码val
		handleValAndValue(item) {
			return item.value === undefined ? item.val : item.value
		},
		handleActive(item) {
			const value = this.formData.search[item.key || this.defaultKey];
			const itemVal = this.handleValAndValue(item);
			return (value === itemVal || (!value && value !== 0 && !itemVal && itemVal !== 0)) ? 'primary' : 'default';
		},
		handleSearch(data) {
			const searchData = {},defaultKey = this.defaultKey;
			const attach = data.attach;
			this.data.forEach(item => {
				const attach = item.attach;
				searchData[item.key || defaultKey] = null;
				if (attach && typeof attach === 'object') {
					Object.keys(attach).forEach((key) => {
						searchData[key] = null;
					})
				}
			});
			searchData[data.key || defaultKey] = this.handleValAndValue(data);
			if (attach && typeof attach === 'object') {
				searchData = { ...searchData, ...attach };
			}
            this.$emit('on-tabs-change', searchData);
			this.$emit('on-search', searchData);
		},
        getRenderProps(data) {
			let { render, style, class: className } = data;
            return [{
                tag: 'div',
                style,
                _key: 0,
                class: className,
                children: render
            }]
		},
	},
}
</script>
